import { getXPlatformTokenDecoded } from '@cosign-services/utils/getXPlatformToken'
import Cookies from 'js-cookie'
import { AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { processEvent } from '../core/processEvent'
import { type DniLoginTypeType } from '../types/base/ga4-events'
import { type RegisterCosignEventsArgs } from './registerCosignEvents'
import { getLoginOrSignUpMethod } from './sendLoginEvent'
import { getCountryCode } from './utils'

const IS_COSIGN_REGISTER_COOKIE_KEY = 'is_cosign_register'
const DNI_LOGIN_TYPE_COOKIE_KEY = 'dni_login_type'
export const sendSignUpEvent = (args: RegisterCosignEventsArgs = {}) => {
  const xPlatformInfo = getXPlatformTokenDecoded()
  const loginOrSignUpMethod = getLoginOrSignUpMethod()
  const isUserSignedUp = Cookies.get(IS_COSIGN_REGISTER_COOKIE_KEY) && xPlatformInfo?.platformUid
  const accountType = Cookies.get(DNI_LOGIN_TYPE_COOKIE_KEY) as DniLoginTypeType

  if (isUserSignedUp && xPlatformInfo?.platformUid) {
    // is_cosign_register 是一次性 flag，觀察到即消耗，避免殘留在日後登入誤噴 sign_up
    Cookies.remove(IS_COSIGN_REGISTER_COOKIE_KEY)

    if (!loginOrSignUpMethod) return

    const { platforms, conversionMap } = args
    const countryCode = getCountryCode(window.location.pathname)

    processEvent({
      event: {
        eventName: 'sign_up',
        eventParams: {
          method: loginOrSignUpMethod,
          user_id: xPlatformInfo.platformUid,
          meta: {
            country_code: countryCode,
            account_type: accountType,
          },
        },
      },
      platforms,
    })

    const conversionLabel = countryCode ? conversionMap?.[countryCode]?.['sign_up'] : undefined
    if (conversionLabel) {
      processEvent({
        event: {
          eventName: 'conversion',
          eventParams: {
            send_to: conversionLabel,
          },
        },
        platforms: [AnalyticsPlatforms.GA4],
      })
    }
  }
}
